import React, { useCallback } from 'react';
import If from '../../../Shared/If/If';
import TextInput from '../../../Shared/TextInput/TextInput';
import BaseInput from '../../../Shared/BaseInput/BaseInput';
import PercentageInput from '../../../Shared/PercentageInput/PercentageInput';
import ValidatedDropdown from '../../../Shared/Dropdown/ValidatedDropdown';
import iconDelete from '../../../../assets/images/icon_delete.svg';
import { BENEFICIARY_TYPES } from '../../../../settings/settings';
// import { coalesce } from '../../../../utils/utils';

import { inputsConfig, typeInput } from './config';
import './BeneficiaryInput.scss';

const BeneficiaryInput = ({
  disabled,
  beneficiary = {},
  onDelete = () => {},
  onUpdate = () => {},
}) => {
  const { entityType, errors = {} } = beneficiary;
  const onChange = useCallback(
    (prop, value) => {
      // if type changed to entity, will set default relationship value
      const defaultProp =
        prop === 'entityType' && value === BENEFICIARY_TYPES.ENTITY
          ? {
              relationship: BENEFICIARY_TYPES.ENTITY,
            }
          : {};
      const newProps =
        prop === 'name'
          ? {
              [prop]: value,
              names: [value],
            }
          : {
              [prop]: value,
            };
      onUpdate({
        id: beneficiary.id,
        props: {
          ...newProps,
          ...defaultProp,
        },
      });
    },
    [beneficiary, onUpdate]
  );

  const dropdownCustomStyle = {
    control: { height: '40px', border: '1px solid #c4c4c4' },
    option: { fontSize: '14px' },
  };

  return (
    <div className="Beneficiary">
      <fieldset
        className={`blocked_data Beneficiary_row ${entityType}`}
        disabled={disabled}
      >
        <div
          className={`blocked_data Beneficiary_row-item -${typeInput.prop}`}
          style={{ order: 0 }}
          key={`type`}
        >
          <label className="required" htmlFor={typeInput.prop}>
            {typeInput.label}
          </label>
          <ValidatedDropdown
            isClearable={false}
            id={typeInput.prop}
            options={typeInput.options}
            required={true}
            preSelected={typeInput.options.find(
              (opt) => opt.value === entityType
            )}
            styles={dropdownCustomStyle}
            onChange={(e) => {
              onChange(typeInput.prop, e.value);
            }}
            isDisabled={disabled}
          />
        </div>

        {inputsConfig[entityType].map((col, i) => (
          <div
            className={`blocked_data Beneficiary_row-item -${col.prop}`}
            //style={{ order: i + 1 }}
            key={`${col.prop}-${i}`}
          >
            <label className={col.required && 'required'} htmlFor={col.prop}>
              {col.label}
            </label>

            <If test={col.input === 'text'}>
              <TextInput
                ariaLabel={`text ${col.prop}`}
                className={`textinput-${col.prop}`}
                defaultValue={beneficiary[col.prop]}
                charPattern={col.charPattern}
                required={col.required}
                maxLength={col.maxLength || 30}
                {...(col.placeholder && { placeholder: col.placeholder })}
                {...(col.cleaveOptions && {
                  cleaveOptions: col.cleaveOptions,
                })}
                onChange={(val, e) => onChange(col.prop, e.target.value)}
                error={beneficiary[col.prop] !== undefined && errors[col.prop]}
              />
            </If>
            <If test={col.input === 'base'}>
              <BaseInput
                id={col.prop}
                defaultValue={beneficiary[col.prop]}
                required={col.required}
                {...(col.cleaveOptions && {
                  cleaveOptions: col.cleaveOptions,
                })}
                onChange={(val) => onChange(col.prop, val)}
                error={beneficiary[col.prop] !== undefined && errors[col.prop]}
              />
            </If>
            <If test={col.input === 'percent'}>
              <PercentageInput
                className={`percentage-${col.prop}`}
                defaultValue={beneficiary[col.prop]}
                required={col.required}
                onChange={(val) => onChange(col.prop, val)}
                error={beneficiary[col.prop] !== undefined && errors[col.prop]}
              />
            </If>
            <If test={col.input === 'dropdown'}>
              <ValidatedDropdown
                isClearable={false}
                id={col.prop}
                options={col.options}
                required={col.required}
                preSelected={
                  col.options &&
                  col.options.find(
                    (opt) =>
                      opt.value === (beneficiary[col.prop] || col.default)
                  )
                }
                styles={dropdownCustomStyle}
                isDisabled={disabled}
                onChange={(e) => onChange(col.prop, e.value)}
                error={beneficiary[col.prop] !== undefined && errors[col.prop]}
              />
            </If>
          </div>
        ))}
        <div
          className=" blocked_data Beneficiary_row-item -delete"
          style={{ order: 10 }}
        >
          <button
            className="Beneficiary_delete"
            disabled={disabled}
            onClick={() => onDelete(beneficiary.id)}
          >
            <img
              src={iconDelete}
              alt="delete"
              className={'delete-button-icon'}
            />
            <div className={'delete-button-text'}>Delete Beneficiary</div>
          </button>
        </div>
      </fieldset>
    </div>
  );
};

export default BeneficiaryInput;
